// "50611092600310104202800100001010015031967167567895.pdf" → "5061109260031…567895.pdf"
// Corta por el medio y conserva siempre la extensión. `max` = largo total aprox.
export function shortFileName(name, max = 28) {
  const s = String(name || '');
  if (s.length <= max) return s;
  const dot = s.lastIndexOf('.');
  const ext = dot > 0 && s.length - dot <= 6 ? s.slice(dot) : '';
  const base = ext ? s.slice(0, dot) : s;
  const room = Math.max(max - ext.length - 1, 6);
  const head = Math.ceil(room * 0.6);
  const tail = room - head;
  return `${base.slice(0, head)}…${tail ? base.slice(-tail) : ''}${ext}`;
}
